import React from "react";
import { LogOut, SquarePen } from "lucide-react"; // or use any icon you prefer
import { useNavigate } from "react-router-dom";
import Button from "./Button";

const Tab = ({
  activeView,
  onToggle,
  setActiveIndex,
  participantTabs,
  onAdd,
  setLoggedIn,
  handleSaveAsDraft,
  formData,
}) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // navigate("/verify-email");
    localStorage.clear();
    setLoggedIn(false);

    // Redirect to login and prevent going back
    navigate("/verify-email", { replace: true });
  };

  return (
    <div className="flex justify-between items-center px-5 py-2 bg-headerLight border-b border-headerBorder">
      <div className="flex gap-4 overflow-x-auto flex-nowrap mr-5">
        <button
          onClick={() => {
            onToggle("my-info");
            setActiveIndex(0);
          }}
          className={`px-4 py-2 text-nowrap ${
            activeView === "my-info"
              ? "text-secondary text-base font-semibold underline"
              : "text-tabBorder text-base font-medium"
          }`}
        >
          My Info
        </button>
        {participantTabs.map((tabId, index) => (
          <button
            key={tabId}
            onClick={() => {
              onToggle(tabId);
              setActiveIndex(index + 1);
            }}
            className={`px-4 py-2 text-nowrap ${
              activeView === tabId
                ? "text-secondary font-semibold underline"
                : "text-tabBorder font-medium"
            }`}
          >
            Second Traveller
            {/* {index + 1} */}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-2">
        {/* {formData.isKnownUser !== "no" && (
          <Button
            title="Save as Draft"
            onClick={handleSaveAsDraft}
            text="Save as Draft"
            iconEnd={<SquarePen size={18} />}
            className="bg-primary text-sm text-white font-normal py-[6px]"
            hideTextOnMobile={true}
          />
        )} */}
        <Button
          title="Log Out"
          onClick={handleLogout}
          text="Exit"
          iconEnd={<LogOut size={18} />}
          className="text-buttonColor text-sm font-semibold px-[10px] py-[6px] border border-buttonColor"
          hideTextOnMobile={true}
        />
      </div>
    </div>
  );
};

export default Tab;
